import { Component ,Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityDialogConstants } from '../../constants/label-constants';

@Component({
  selector: 'app-active-inactive-dialog',
  templateUrl: './active-inactive-dialog.component.html',
  styleUrls: ['./active-inactive-dialog.component.scss']
})
export class ActiveInactiveDialogComponent {
  
  @Input() title!: string;
  @Input() message!: string;
  @Input() FieldName!: string;
  labelConstants : any = ActivityDialogConstants;

  constructor(public activeModal: NgbActiveModal) { }

  onClose(type: string) {
    this.activeModal.close(type);
  }
}